// extracted by mini-css-extract-plugin
module.exports = {"shareLinksContent":"SocailLoginLinks_shareLinksContent__w4kTM"};